export default __webpack_public_path__ + "static/media/notion.58a56774.svg";